export default {
    eyeButton: {
      hidePassword: 'Hide password',
      showPassword: 'Show password',
      ariaLabel: 'Password visibility toggle button',
    },
    header: {
      title: 'PAMM Marketplace',
      subtitle:
        'Smart investing starts here — supporting 3,000+ financial derivative assets',
    },
    layout: {
      tabs: {
        pammSignal: 'PAMM Signals',
        pammAssets: 'Subscribed',
        pammStrategys: 'Published',
        pammOrders: 'Order Details',
        shareRecommend: 'Share/Recommend',
      },
    },
    subscription: {
      modal: {
        subscribeTitle: 'Subscribe',
        redeemTitle: 'Redeem',
      },
      placeholder: {
        pammName: 'PAMM Name',
        input: 'Please input',
      },
      labels: {
        payAccount: 'Pay Account',
        subscribeAmount: 'Subscribe Amount',
        redeemAmount: 'Redeem Amount',
        fundPassword: 'Fund Password',
        deductedAmount: 'Amount deducted from account',
        exchangeRate: 'Exchange Rate',
      },
      select: {
        payAccountPlaceholder: 'Please select pay account',
        selectPayAccountHelp: 'Please select the account to deduct investment funds',
        selectSettlementAccountHelp: 'Please select the account to settle funds',
      },
      actions: {
        confirmSubscribe: 'Confirm Subscribe',
        confirmRedeem: 'Confirm Redeem',
        all: 'All',
      },
      rules: {
        fundPasswordRequired: 'Please enter fund password',
        fundPasswordPattern: 'Fund password must be 6 digits',
        amountGreaterThanZero: 'Amount must be greater than 0',
        amountNotExceedBalance: "Amount must not exceed account balance",
      },
      tips: {
        redeemRange: 'Redeem amount 500.00 USD-100,000.00 USD',
        minimumInvestment: 'Minimum investment - 500.00 USD',
        redeemNotExceedBalance: 'Redeem amount must not exceed account balance',
        balanceZeroRedeemAll: "Account balance is 0, can't redeem all",
        balanceInsufficientRedeemAll: "Insufficient balance, can't redeem all",
      },
      notify: {
        successTitle: 'Success',
        subscribeSuccess: 'Follow started successfully',
        redeemSuccess: 'Redeemed successfully',
      },
    },
}